import React from 'react';
import {
  CheckCircle2, AlertCircle, AlertTriangle, HelpCircle, Clock, Bot,
  Send, ThumbsUp, ThumbsDown, ArrowUpRight, Zap, Loader2, Ban,
  Eye, Phone, PhoneCall, TrendingUp, ShieldCheck,
} from 'lucide-react';

// Single source of truth for status → color + icon + label across the app.
const MAP = {
  // network
  in_network: { cls: 'pill-green', icon: CheckCircle2, label: 'In-network' },
  out_of_network: { cls: 'pill-red', icon: AlertCircle, label: 'Out-of-network' },
  unknown: { cls: 'pill-amber', icon: HelpCircle, label: 'Unknown' },
  not_in_db: { cls: 'pill-amber', icon: AlertTriangle, label: 'Unknown — verify' },
  // network trust lifecycle (observed → calling → confirmed → building → established)
  observed: { cls: 'pill-slate', icon: Eye, label: 'Observed' },
  calling: { cls: 'pill-amber', icon: Phone, label: 'Calling to confirm' },
  confirmed: { cls: 'pill-sky', icon: PhoneCall, label: 'Confirmed' },
  building: { cls: 'pill-indigo', icon: TrendingUp, label: 'Building confidence' },
  established: { cls: 'pill-green', icon: ShieldCheck, label: 'Established' },
  // coverage
  active: { cls: 'pill-green', icon: CheckCircle2, label: 'Active' },
  inactive: { cls: 'pill-red', icon: Ban, label: 'Inactive' },
  // verification / appointment
  verified: { cls: 'pill-green', icon: CheckCircle2, label: 'Verified' },
  needs_verification: { cls: 'pill-amber', icon: Clock, label: 'Needs verification' },
  risk_flagged: { cls: 'pill-red', icon: AlertTriangle, label: 'Risk flagged' },
  // agent state
  auto_cleared: { cls: 'pill-green', icon: Zap, label: 'Auto-cleared' },
  cleared: { cls: 'pill-green', icon: CheckCircle2, label: 'Cleared' },
  flagged: { cls: 'pill-amber', icon: AlertTriangle, label: 'Flagged' },
  queued: { cls: 'pill-slate', icon: Clock, label: 'Queued' },
  running: { cls: 'pill-indigo', icon: Loader2, label: 'Running' },
  // workflow status
  awaiting_review: { cls: 'pill-amber', icon: Clock, label: 'Awaiting review' },
  approved: { cls: 'pill-green', icon: ThumbsUp, label: 'Approved' },
  rejected: { cls: 'pill-slate', icon: ThumbsDown, label: 'Rejected' },
  auto_resolved: { cls: 'pill-green', icon: Zap, label: 'Auto-resolved' },
  escalated: { cls: 'pill-red', icon: ArrowUpRight, label: 'Escalated' },
  sent: { cls: 'pill-sky', icon: Send, label: 'Sent' },
  applied: { cls: 'pill-green', icon: CheckCircle2, label: 'Applied' },
  // generic task
  pending: { cls: 'pill-amber', icon: Clock, label: 'Pending' },
  done: { cls: 'pill-green', icon: CheckCircle2, label: 'Done' },
  // claims
  paid: { cls: 'pill-green', icon: CheckCircle2, label: 'Paid' },
  denied: { cls: 'pill-red', icon: AlertCircle, label: 'Denied' },
  // risk
  high: { cls: 'pill-red', icon: AlertCircle, label: 'High' },
  medium: { cls: 'pill-amber', icon: AlertTriangle, label: 'Medium' },
  low: { cls: 'pill-sky', icon: CheckCircle2, label: 'Low' },
  clear: { cls: 'pill-green', icon: CheckCircle2, label: 'Clear' },
  // agent attribution
  ai: { cls: 'pill-violet', icon: Bot, label: 'AI' },
};

export default function StatusPill({ status, label, className = '' }) {
  const cfg = MAP[status] || { cls: 'pill-slate', icon: HelpCircle, label: label || status };
  const Icon = cfg.icon;
  return (
    <span className={`pill ${cfg.cls} ${className}`}>
      <Icon className={`h-3 w-3 ${status === 'running' ? 'animate-spin' : ''}`} />
      {label || cfg.label}
    </span>
  );
}
